import { memo } from 'react';

import { Text, TextProps } from '@chakra-ui/react';

export const SubHeading = memo<TextProps>((props) => {
	return <Text fontSize="2xl" fontWeight="semibold" mb={6} mt={10} textAlign="center" {...props} />;
});
